import React, { useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  HOME_CANONICAL,
  PRESCRIPTION_CANONICAL
} from '../../constants/defaults';
import RelatedDrugs from '../prescription-2/RelatedDrugs';
import RelatedArticles from '../common/RelatedArticles/index.jsx';
import _ from 'lodash';
import { array, string, object } from 'prop-types';
import LeftMenu from './LeftMenu';
import Breadcrumb from './Breadcrumb';
import { getLdJson } from './drugDetailLdJson';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SkipTo from '../common/Tag/SkipTo';
import PopularDrugs from '../common/PopularDrugs';
import { GPT_HEAD_WHAT_IS_PAGE } from '../../constants/gptHeadTags/whatIsPage';
import AdSlot from '../dfp/AdSlot';
import {
  injectHorizontalAds,
  insertVerticalAds
} from '../dfp/DynamicAdsInjection';
import { ADS_PLACEMENT } from '../prescription-2/Advertisting/Constant';
import {
  AVERAGE_HORIZONTAL_AD_HEIGHT,
  AVERAGE_VERTICAL_AD_HEIGHT,
  HORIZONTAL_ADS_CONTAINER_ID,
  MINIMUM_AD_SPACING,
  VERTICAL_ADS_CONTAINER_ID
} from '../../constants/gptHeadTags/common';
import AuthorProfile from '../common/AuthorProfile';
import FactCheckModal from '../common/FactCheckModal';
import KeyTakeawaysSection from '../common/KeyTakeawaysSection';
import PublishedDate from '../common/PublishedDate/index.js';
import PatientCompassAd from '../common/PatientCompassAd/index.js';
import RelatedSection from '../common/RelatedSection/index.js';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const getDimensions = ele => {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom
  };
};

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

const DrugDetailLayout = props => {
  const {
    drugName,
    sectionList,
    drugSectionList,
    blogData,
    imageData,
    cmsData,
    seoName,
    replaceableVariables,
    dosageGuideSlug,
    popularDrugs,
    patientCompassData,
    isNormalDrug
  } = props;
  let items = [{ to: '/', label: 'Home' }];
  if (cmsData && cmsData.drugActive) {
    items.push({
      to: `/prescription/${cmsData && cmsData.seoName}`,
      label: `${drugName} Coupons`
    });
  }
  const [visibleSection, setVisibleSection] = useState();
  const headerRef = useRef(null);
  const overview = useRef(null);
  const uses = useRef(null);
  const forms = useRef(null);
  const dosage = useRef(null);
  const images = useRef(null);
  const directions = useRef(null);
  const dose = useRef(null);
  const contraindications = useRef(null);
  const warnings = useRef(null);
  const effects = useRef(null);
  const interactions = useRef(null);
  const relatedDrug = useRef(null);
  const relatedArticles = useRef(null);
  const descSection = useRef(null);
  const relatedCondition = useRef(null);
  const medicalReviewer = cmsData?.medicalReviewer;
  const isNoIndex =
    !_.isEmpty(cmsData) && cmsData.index
      ? _.isEmpty(cmsData?.howToTakeIt)
      : !cmsData.index;

  const sectionRefs = [
    { section: 'Overview', ref: overview },
    { section: 'Uses', ref: uses },
    { section: 'Forms', ref: forms },
    { section: 'Dosage', ref: dosage },
    { section: 'Images', ref: images },
    { section: 'Directions', ref: directions },
    { section: 'Missed a dose', ref: dose },
    { section: 'Contraindications', ref: contraindications },
    { section: 'Warnings', ref: warnings },
    { section: 'Interactions', ref: interactions },
    { section: 'Side effects', ref: effects },
    { section: 'Related drugs', ref: relatedDrug },
    { section: 'Related conditions', ref: relatedCondition },
    { section: 'Research', ref: relatedArticles }
  ];
  const isAdsVisible = API.ENABLE_GLOBAL_ADS && API.ALLOW_WHAT_IS_PAGE_ADS;
  const cmsDataHeading = cmsData?.whatIsPageMasterTemplateHeadings || {};

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 150;

    const selected = sectionRefs.find(({ ref }) => {
      const ele = ref.current;
      if (ele) {
        const { offsetBottom, offsetTop } = getDimensions(ele);
        return scrollPosition > offsetTop && scrollPosition < offsetBottom;
      }
    });
    if (selected && selected.section !== visibleSection) {
      setVisibleSection(selected.section);
    } else if (!selected && visibleSection) {
      setVisibleSection(undefined);
    }
  };

  const renderImagesData = () => {
    if (imageData && !_.isEmpty(imageData.images)) {
      return (
        <div className="imagesSection">
          <h2>{cmsDataHeading?.imagesSectionHead}</h2>
          <ul>
            {imageData.images.map((item, id) => {
              return (
                <li key={id}>
                  <LazyLoadImage
                    src={item.url}
                    alt={`${imageData.drugName} ${item.dosage} ${item.form}`}
                  />
                  <p>
                    {imageData.drugName} <br />
                    {item.dosage.toLowerCase()} {item.form}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
    return null;
  };

  const handleBottomAdScroll = () => {
    const viewportHeight = window.innerHeight;
    const bottomTriggerElement = document.querySelector('.homepage-footer');
    const anchorDiv = document.getElementById('bottomStickyAd');
    // Check if the user has scrolled at least 1.5 times the height of the viewport
    if (window.scrollY >= 1.5 * viewportHeight) {
      // Check if the footer is visible
      if (bottomTriggerElement.getBoundingClientRect().top <= viewportHeight) {
        // Show the anchor div
        anchorDiv.classList.remove('bottomAdsBanner');
      } else {
        // Hide the anchor div
        anchorDiv.classList.add('bottomAdsBanner');
      }
    } else {
      // Hide the anchor div
      anchorDiv.classList.remove('bottomAdsBanner');
    }
  };

  useEffect(() => {
    if (isAdsVisible) {
      const { sizeMapping } = window;
      const onSizeMappingLoad = () => {
        const VERTICAL_RIGHT_SIDE_ADS = [
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_right-hand_1st',
            id: 'div-gpt-ad-1686416716691-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_right-hand_2nd',
            id: 'div-gpt-ad-1686416751317-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_right-hand_3rd',
            id: 'div-gpt-ad-1686416796012-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_right-hand_4th',
            id: 'div-gpt-ad-1686416849087-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_right-hand_5th',
            id: 'div-gpt-ad-1686416886264-0',
            size: sizeMapping.leftRight
          }
        ];
        const HORIZONTAL_ADS = [
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_in-content-1st',
            id: 'div-gpt-ad-1686416500267-0',
            size: sizeMapping.inContent
          },
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_in-content-2nd',
            id: 'div-gpt-ad-1686416540653-0',
            size: sizeMapping.inContent
          },
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_in-content-3rd',
            id: 'div-gpt-ad-1686416575506-0',
            size: sizeMapping.inContent
          },
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_in-content-4th',
            id: 'div-gpt-ad-1686416616637-0',
            size: sizeMapping.inContent
          },
          {
            path: '/22809915073/SingleCare_What-is/What-is-page_in-content-5th',
            id: 'div-gpt-ad-1686416646953-0',
            size: sizeMapping.inContent
          }
        ];
        const VERTICAL_LEFT_SIDE_ADS = [
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_left-hand_1st',
            id: 'div-gpt-ad-1707247531111-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_left-hand_2nd',
            id: 'div-gpt-ad-1707257245168-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_left-hand_3rd',
            id: 'div-gpt-ad-1707257392071-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/22809915073/SingleCare_What-is/what-is-page_left-hand_4th',
            id: 'div-gpt-ad-1707257480408-0',
            size: sizeMapping.leftRight
          },
          {
            path: '/228/22809915073/SingleCare_What-is/what-is-page_left-hand_5th',
            id: 'div-gpt-ad-1707257534571-0',
            size: sizeMapping.leftRight
          }
        ];

        insertVerticalAds(
          VERTICAL_RIGHT_SIDE_ADS,
          `[data-ads-container="${VERTICAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_RIGHT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );

        insertVerticalAds(
          VERTICAL_LEFT_SIDE_ADS,
          `[data-ads-container="${VERTICAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_LEFT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );

        injectHorizontalAds(
          HORIZONTAL_ADS,
          `[data-ads-container="${HORIZONTAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_IN_CONTENT}"]`,
          '#app',
          AVERAGE_HORIZONTAL_AD_HEIGHT,
          isAdsVisible,
          MINIMUM_AD_SPACING
        );
      };
      if (typeof sizeMapping !== 'undefined') {
        if (sizeMapping.inContent) {
          onSizeMappingLoad();
        } else {
          const sizeMappingListener = () => {
            if (sizeMapping.inContent) {
              return onSizeMappingLoad();
            }
            return setTimeout(sizeMappingListener, 200);
          };
          sizeMappingListener();
        }
      }
      const anchorDiv = document.getElementById('bottomStickyAd');
      const viewportHeight = window.innerHeight;
      // Check if the total page is is at least 3X if the viewport height
      if (document.body.scrollHeight >= 3 * viewportHeight) {
        // Show the anchor div
        window.addEventListener(
          'scroll',
          _.throttle(handleBottomAdScroll, 250)
        );
      } else {
        anchorDiv.classList.remove('bottomAdsBanner');
      }
    }
    return () => {
      isAdsVisible &&
        window.removeEventListener('scroll', handleBottomAdScroll);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView();
      }
    }
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useDidMountEffect(() => {
    handleScroll();
  }, [visibleSection]);

  const displayAuthorProfile = (withDiscription = false) =>
    medicalReviewer && (
      <AuthorProfile
        authorTitle={'Medically reviewed by'}
        authorProfileLink={medicalReviewer?.reviewerPageOnSingleCare}
        authorDes={medicalReviewer?.title}
        authorName={medicalReviewer?.name}
        authorQualifications={medicalReviewer?.qualifications}
        authorImg={medicalReviewer?.photo}
        description={
          withDiscription &&
          documentToReactComponents(
            JSON.parse(medicalReviewer?.biography || null)
          )
        }
      />
    );

  return (
    <div className="DrugDetailsMain">
      <div className="fixedactionButton">
        <div className="stickyLeftNav mobile-tablel">
          <LeftMenu
            sectionList={sectionList}
            visibleSection={visibleSection}
            seoName={seoName}
            drugSectionList={drugSectionList}
            dosageGuideSlug={dosageGuideSlug}
          />
        </div>
      </div>
      <section className="homepage-new DrugDetailsContent" ref={headerRef}>
        <Helmet>
          <title>{cmsDataHeading?.title}</title>
          <meta name="description" content={cmsDataHeading?.metaDescription} />
          {isNoIndex && (
            <meta
              name="ROBOTS"
              content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
            />
          )}
          <link
            rel="canonical"
            href={
              !_.isEmpty(cmsData.canonicalUrl)
                ? `${HOME_CANONICAL}/${cmsData.canonicalUrl}`
                : `${PRESCRIPTION_CANONICAL}${props.match.params.drugName.toLowerCase()}/what-is`
            }
          />
          <script type="application/ld+json">
            {getLdJson(
              drugName,
              replaceableVariables,
              imageData,
              props.match.params.drugName.toLowerCase()
            )}
          </script>
          {isAdsVisible && (
            <script async rel="preload">
              {GPT_HEAD_WHAT_IS_PAGE}
            </script>
          )}
          <meta property="seo_name" content={seoName} />
          <meta property="placement_name" content="what-is_page" />
        </Helmet>

        <section className="desktop-only">
          <div className="stickyLeftNav">
            <LeftMenu
              sectionList={sectionList}
              visibleSection={visibleSection}
              seoName={seoName}
              drugSectionList={drugSectionList}
              dosageGuideSlug={dosageGuideSlug}
            />
          </div>
        </section>
        <section className="contentDescription mobile-section">
          <div className="topBannerAds">
            <div className="adsInTopCenter">
              <AdSlot
                id="div-gpt-ad-1686416451828-0"
                featureDisplayAdsFlag={isAdsVisible}
              />
            </div>
          </div>
          <section className="mainAllSection">
            <div
              className="leftAdsBannerContainer"
              data-ads-container={
                VERTICAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_LEFT_SIDE
              }
            ></div>
            <section className="mainDetailsContainer">
              <Breadcrumb
                items={items}
                ariaLabel={`Navigation menu for What is ${drugName}`}
              >
                {items.map(({ to, label }) => (
                  <a key={label} href={to}>
                    {label}
                  </a>
                ))}
                <span>{`What is ${drugName}`}</span>
              </Breadcrumb>
              {/* Note : do not remove data-ads-container attribute from dom */}
              <section
                className="DescriptionSection mobile-section"
                ref={descSection}
                data-ads-container={
                  HORIZONTAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_IN_CONTENT
                }
              >
                <SkipTo>
                  <h1>{cmsDataHeading?.h1}</h1>
                </SkipTo>
                <div>
                  {medicalReviewer && (
                    <div className="userDataInfo">
                      {displayAuthorProfile(false)}
                    </div>
                  )}
                  <PublishedDate
                    publishedAt={cmsData?.publishedAt}
                    updatedAt={cmsData?.lastUpdatedDate}
                  >
                    {medicalReviewer && <FactCheckModal />}
                  </PublishedDate>
                </div>
                {!_.isEmpty(cmsData) &&
                  !_.isEmpty(cmsData.introText) &&
                  documentToReactComponents(JSON.parse(cmsData.introText))}
                {isNormalDrug && (
                  <p
                    className={`drug-page-link ${
                      !_.isEmpty(cmsData) && !_.isEmpty(cmsData.introText)
                        ? ''
                        : 'remove-padding'
                    }`}
                  >
                    <a
                      href={`/prescription/${
                        cmsData && cmsData.seoName
                      }#what-is`}
                    >{`Check our best ${drugName} prices`}</a>
                  </p>
                )}
                <section
                  className="overviewSection mobile-section"
                  id="overview"
                  ref={overview}
                >
                  {cmsData && <h2>{cmsDataHeading?.descriptionText}</h2>}

                  <div className="listRow">
                    {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.brandNames) && (
                      <div className="overviewItem">
                        <h3>BRAND NAMES:</h3>
                        {documentToReactComponents(
                          JSON.parse(cmsData.brandNames)
                        )}
                      </div>
                    )}
                    {!_.isEmpty(cmsData) &&
                      !_.isEmpty(cmsData.genericNames) && (
                        <div className="overviewItem">
                          <h3>Generic Names:</h3>
                          {documentToReactComponents(
                            JSON.parse(cmsData.genericNames)
                          )}
                        </div>
                      )}
                    {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.uses) && (
                      <div className="overviewItem">
                        <h3>Uses:</h3>
                        {documentToReactComponents(JSON.parse(cmsData.uses))}
                      </div>
                    )}
                  </div>
                  <div className="listRow">
                    {!_.isEmpty(cmsData) &&
                      !_.isEmpty(cmsData.therapeuticClasses) && (
                        <div>
                          <h3 className="therapeuticLabel">
                            Therapeutic Classes:
                          </h3>
                          <div id="drug-monograph-therapeuticClasses">
                            {documentToReactComponents(
                              JSON.parse(cmsData.therapeuticClasses)
                            )}
                          </div>
                        </div>
                      )}
                    {/* {drugInfo.monoGraphData &&
                  !_.isEmpty(drugInfo.drug.deaClassCode) && (
                    <div className="overviewItem">
                      <strong>Dea drug class:</strong>
                      <span>{drugInfo.drug.deaClassCode}</span>
                    </div>
                  )}*/}
                    {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.forms) && (
                      <div className="overviewItem">
                        <h3>Forms:</h3>
                        {!_.isEmpty(cmsData) &&
                          !_.isEmpty(cmsData.forms) &&
                          documentToReactComponents(JSON.parse(cmsData.forms))}
                      </div>
                    )}
                    {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.howItsTaken) && (
                      <div className="overviewItem">
                        <h3>How it’s taken:</h3>
                        {documentToReactComponents(
                          JSON.parse(cmsData.howItsTaken)
                        )}
                      </div>
                    )}
                  </div>
                </section>

                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.whatIsUsedFor) && (
                  <section id="uses" className="mobile-section" ref={uses}>
                    <h2>{cmsDataHeading?.whatIsUsedFor}</h2>
                    {documentToReactComponents(
                      JSON.parse(cmsData.whatIsUsedFor)
                    )}
                  </section>
                )}

                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.keyTakeaways) && (
                  <KeyTakeawaysSection
                    keyTakeaways={JSON.parse(cmsData.keyTakeaways)}
                  />
                )}
                {!_.isEmpty(cmsData) &&
                  !_.isEmpty(cmsData.whatFormsDoesDrugComeIn) && (
                    <section id="forms" className="mobile-section" ref={forms}>
                      <h2>{cmsDataHeading?.whatFormsDoesDrugComeIn}</h2>

                      {documentToReactComponents(
                        JSON.parse(cmsData.whatFormsDoesDrugComeIn)
                      )}
                    </section>
                  )}
                <PatientCompassAd
                  patientCompassData={patientCompassData}
                  seoName={seoName}
                  placementPage={ADS_PLACEMENT.WHAT_IS_PAGE}
                  cssClassName="patientCompassWhatIs"
                />
                {!_.isEmpty(cmsData) &&
                  !_.isEmpty(cmsData.whatAreCommonDoses) && (
                    <section
                      id="dosage"
                      className="mobile-section"
                      ref={dosage}
                    >
                      <h2>{cmsDataHeading?.whatAreCommonDoses}</h2>
                      {documentToReactComponents(
                        JSON.parse(cmsData.whatAreCommonDoses)
                      )}
                    </section>
                  )}
                <section id="images" ref={images}>
                  {renderImagesData()}
                </section>
                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.howToTakeIt) && (
                  <section
                    id="directions"
                    className="sectionData mobile-section"
                    ref={directions}
                  >
                    <h2>{cmsDataHeading?.howToTakeIt}</h2>
                    {documentToReactComponents(JSON.parse(cmsData.howToTakeIt))}
                  </section>
                )}
                {!_.isEmpty(cmsData) &&
                  !_.isEmpty(cmsData.whatToDoIfYouMissADose) && (
                    <section
                      id="dose"
                      ref={dose}
                      className="sectionData mobile-section"
                    >
                      <h2>{cmsDataHeading?.whatToDoIfYouMissADose}</h2>
                      {documentToReactComponents(
                        JSON.parse(cmsData.whatToDoIfYouMissADose)
                      )}
                    </section>
                  )}

                {!_.isEmpty(cmsData) &&
                  !_.isEmpty(cmsData.contraindications) && (
                    <section
                      id="contraindications"
                      ref={contraindications}
                      className="sectionData mobile-section"
                    >
                      <h2>{cmsDataHeading?.contraindications}</h2>
                      {documentToReactComponents(
                        JSON.parse(cmsData.contraindications)
                      )}
                    </section>
                  )}
                {/* <section id="storage" ref={storage} className="sectionData">
            {renderMonographData(
              `How to Store ${drugName}`,
              drugInfo.monoGraphData && drugInfo.monoGraphData.storageDisposals
            )}
          </section>*/}
                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.warnings) && (
                  <section
                    id="warnings"
                    ref={warnings}
                    className="sectionData mobile-section"
                  >
                    <h2>{cmsDataHeading?.warnings}</h2>
                    {documentToReactComponents(JSON.parse(cmsData.warnings))}
                  </section>
                )}
                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.interactions) && (
                  <section
                    id="interactions"
                    ref={interactions}
                    className="sectionData mobile-section"
                  >
                    <h2>{cmsDataHeading?.interactions}</h2>
                    {documentToReactComponents(
                      JSON.parse(cmsData.interactions)
                    )}
                  </section>
                )}
                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.sideEffects) && (
                  <section
                    id="side-effects"
                    className="mobile-section"
                    ref={effects}
                  >
                    <div className="sideEffectsContainer">
                      <h2>{cmsDataHeading?.sideEffects}</h2>
                      {documentToReactComponents(
                        JSON.parse(cmsData.sideEffects)
                      )}
                    </div>
                  </section>
                )}

                {!_.isEmpty(cmsData) && !_.isEmpty(cmsData.sources) && (
                  <section className="mobile-section">
                    <div>
                      <h2>{cmsDataHeading.sources}:</h2>
                      {documentToReactComponents(JSON.parse(cmsData.sources))}
                    </div>
                  </section>
                )}

                <section
                  id="related-drugs"
                  ref={relatedDrug}
                  className="relatedDrugs mobile-section"
                >
                  {!_.isEmpty(cmsData && cmsData.drugPage) && (
                    <RelatedDrugs
                      relatedDrugs={cmsData && cmsData.drugPage}
                      isWhatIs={true}
                      isFromCms={true}
                      title={cmsDataHeading?.drugPage}
                    />
                  )}
                </section>
                <section id="related-conditions" ref={relatedCondition}>
                  {!_.isEmpty(cmsData && cmsData.relatedConditions) && (
                    <RelatedSection
                      heading="Related Conditions"
                      slugPrefix="/conditions"
                      isLimited={false}
                      relatedData={cmsData.relatedConditions}
                      id="related-conditions"
                    />
                  )}
                </section>
                <section id="research" ref={relatedArticles}>
                  {!_.isEmpty(blogData) && (
                    <RelatedArticles
                      blogData={blogData}
                      drugName={drugName}
                      cmsTitle={cmsDataHeading?.relatedContentSection}
                    />
                  )}
                </section>
                {!_.isEmpty(popularDrugs) && (
                  <PopularDrugs popularDrugs={popularDrugs} text="coupons" />
                )}
              </section>
              <div className="bottomUserDataInfo">
                <div className="authorLists">{displayAuthorProfile(true)}</div>
              </div>
            </section>
            {/* Note : do not remove data-ads-container attribute from dom */}
            <div
              className="rightAdsBannerContainer"
              data-ads-container={
                VERTICAL_ADS_CONTAINER_ID.WHAT_IS_PAGE_RIGHT_SIDE
              }
            ></div>
          </section>
          <div className="adsInCenter marginBottom-20">
            <AdSlot
              id="div-gpt-ad-1686416681656-0"
              featureDisplayAdsFlag={isAdsVisible}
            />
          </div>
        </section>
      </section>
      <div id="bottomStickyAd" className="bottomLastAds">
        <AdSlot
          id="div-gpt-ad-1686416923171-0"
          enableCloseBtn={true}
          innerDivClassName="p-1"
          featureDisplayAdsFlag={isAdsVisible}
        />
      </div>
    </div>
  );
};
DrugDetailLayout.propTypes = {
  drugName: string,
  defaultStructure: object,
  sectionList: array,
  blogData: array,
  imageData: object
};

DrugDetailLayout.defaultProps = {
  drugName: '',
  defaultStructure: {},
  sectionList: [],
  blogData: [],
  imageData: {}
};

export default withRouter(DrugDetailLayout);
